const ADD_GCP_ACCOUNT = "ADD_GCP_ACCOUNT";
const ADD_GCP_ACCOUNT_SUCCESS = "ADD_GCP_ACCOUNT_SUCCESS";
const ADD_GCP_ACCOUNT_ERROR = "ADD_GCP_ACCOUNT_ERROR";

export const addGCPAccountInfo = (params) => ({
  type: ADD_GCP_ACCOUNT,
  params,
});

export { ADD_GCP_ACCOUNT, ADD_GCP_ACCOUNT_SUCCESS, ADD_GCP_ACCOUNT_ERROR };
